import React, { useState, useEffect } from "react";
import { Modal, Button } from "antd";
import { useDispatch } from "react-redux";
import { setError } from "../../../store/reducers";
import SalesService from "../../../services/Sales.services";
import localStorageContent from "../../../utils/localstorage";

const { confirm } = Modal;

interface Props {
  showDeleteModal: boolean;
  toggleDeleteModal: (data: any) => void;
  editUser: any;
  currentPage: number;
  queryString: any;
  getSalesListData: (page: number, query: any) => Promise<void>;
}
const localUserData = localStorageContent.getUserData();
const DeleteModal: React.FC<Props> = ({
  showDeleteModal,
  toggleDeleteModal,
  editUser,
  currentPage,
  queryString,
  getSalesListData,
}) => {
  const dispatch = useDispatch();
  const { deleteSalesData } = SalesService;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [resolvedId, setResolvedId] = useState<any>(null);

  // Resolve id when editUser changes
  useEffect(() => {
    const id =
      editUser?.id ??
      editUser?.lead_id ??
      editUser?.contact_id ??
      editUser?._id ??
      null;
    setResolvedId(id);
  }, [editUser]);

  const handleDelete = async () => {
    confirm({
      title: "Delete Contact",
      content: `Are you sure you want to delete ${
        editUser?.name || "this contact"
      }?`,
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk: async () => {
        const id = editUser?.id ?? editUser?.lead_id ?? editUser?._id;
        if (!id) {
          dispatch(
            setError({
              status: true,
              type: "error",
              message: "Contact ID not found.",
            })
          );
          return;
        }

        const payload = {
          deletedBy: localUserData?.user_id || "admin",
          user_role: localUserData?.role || null,
        };

        try {
          setIsLoading(true);
          console.log("[DeleteModal] calling deleteSalesData:", id, payload);
          const response = await deleteSalesData(id, payload);
          console.log("[DeleteModal] delete response:", response);
          if (response) {
            await getSalesListData(currentPage, queryString);
            toggleDeleteModal(null);
            dispatch(
              setError({
                status: true,
                type: "success",
                message: "Deleted successfully",
              })
            );
          }
        } catch (err: any) {
          console.error("[DeleteModal] delete error:", err);
          if (err?.response)
            console.error("server:", err.response.status, err.response.data);
          dispatch(
            setError({
              status: true,
              type: "error",
              message:
                err?.response?.data?.message || err?.message || "Delete failed",
            })
          );
        } finally {
          setIsLoading(false);
        }
      },
    });
  };

  return (
    <Modal
      title="Delete Contact"
      open={showDeleteModal}
      onCancel={() => toggleDeleteModal(null)}
      footer={[
        <Button
          key="cancel"
          onClick={() => toggleDeleteModal(null)}
          disabled={isLoading}
        >
          Cancel
        </Button>,
        <Button key="delete" danger onClick={handleDelete} loading={isLoading}>
          Delete
        </Button>,
      ]}
    >
      <p>
        Are you sure you want to delete <br></br>
        <strong>{editUser?.name ?? "this contact"}</strong>?
      </p>
      <p>
        <small>Resolved id: {resolvedId ?? "not found (check console)"}</small>
      </p>
    </Modal>
  );
};

export default DeleteModal;
